import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import { useSettings } from '../../../hooks/useSettings';

export const HomeBanner = () => {
  const [settings] = useSettings();
  const bannerText = settings?.bannerOptions?.text ?? '';
  const enrollmentAvailable = settings?.enrollmentAvailable ?? false;

  if (!settings?.bannerOptions?.visible || !bannerText) {
    return null;
  }

  return (
    <Box
      position="sticky"
      top={0}
      zIndex={10}
      bg="orange.500"
      color="white"
    >
      <Flex align="center" gap={3} px={3} py={2} minH="52px">
        <Text
          flex="1"
          minW={0}
          fontSize={{ base: 'xs', sm: 'sm', md: 'md' }}
          fontWeight="semibold"
          textTransform="uppercase"
          letterSpacing="wider"
          textAlign="center"
          whiteSpace="normal"
          lineHeight="1.2"
          overflowWrap="anywhere"
        >
          {bannerText}
        </Text>

        {enrollmentAvailable && (
          <NavLink to="/zapisy">
            <Button
              size="sm"
              colorPalette="whiteAlpha"
              variant="solid"
              fontWeight="bold"
              color="brand.900"
              bg="white"
              _hover={{ bg: 'gray.100' }}
              flexShrink={0}
            >
              Sprawdź terminy
            </Button>
          </NavLink>
        )}
      </Flex>
    </Box>
  );
};

export default HomeBanner;
